import * as React from 'react';
import {
    VerificationService,
    SuccessResponse,
    FormFooterComponent
} from '@sheerid/jslib';


interface StepSuccessProps {
    verificationService: VerificationService;
}

const StepSuccessComponent = ({ verificationService }: StepSuccessProps) => {
    return (
        <div id="sid-step-success" className="sid-l-container">
            <div className="sid-header">
                <div className="sid-header-success__logo">
                    <img src="logo.png" alt="logo"/>
                </div>
                <div className="sid-header__title sid-l-space-top-lg">
                    Success
                </div>
                <span className="sid-header-success__subtitle">
                    You've been verified. Below is your single-use coupon code. Your single-use coupon code can be used during checkout on <a className="sid-blue-link" href="https://purple.com/mattresses" target="_blank" rel="noopener noreferrer">purple.com</a>. The coupon can be combined with any other offer or promotion.
                </span>
            </div>

            <div className="sid-reward-code sid-l-space-top-md sid-h-jumbo-text">
                {(verificationService.verificationResponse as SuccessResponse).rewardCode || '${rewardCode}'}
            </div>

            <div className="sid-success-footer-one">
                <p className="sid-success-footer-p-one">
                    Please return to <a className="sid-blue-link" href="https://purple.com/mattresses" target="_blank" rel="noopener noreferrer">purple.com</a> to continue shopping.
                </p>
            </div>

            <div className="sid-success-footer-three">
                <p className="sid-success-footer-p-three">
                    We're also emailing you a copy of your code so that you can shop now, or shop later. Please check for an email from verify@sheerid.com for details.
                </p>
            </div>

            <div className="sid-h-small-text">
                <FormFooterComponent verificationService={verificationService} />
            </div>

        </div>
    );
};


export { StepSuccessComponent };
